// API Configuration
const config = {
  // Use local backend for development
  API_BASE_URL: "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net",
  
  // Production URL (commented out for local development)
  // API_BASE_URL: "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net",
};

export default config;